import { dataHooks } from '@wix/data-hooks'

export const wixStudioInputGroupDataHooks = dataHooks<{
  title: {}
  option: { id: string }
  nextButton: {}
  inputGroupLabel: {}
}>('wixStudioInputGroup')
